import { Menu } from "Models/Menu";

export default class MenuItems {
    public static readonly MAIN_MENU: Menu[] = [
        {
            key: "home",
            url: "/home",
            allowedRoles: []
        },
        {
            key: "tasktemplates",
            url: "/tasktemplates",
            allowedRoles: []
        },
        {
            key: "checklisttemplates",
            url: "/checklisttemplates",
            allowedRoles: []
        },
        {
            key: "audittemplates",
            url: "/audittemplates",
            allowedRoles: []
        },
        {
            key: "actions",
            url: "/actions",
            allowedRoles: []
        },
        {
            key: "companies",
            url: "/companies",
            allowedRoles: ["superuser"]
        }
    ];
}


// WEBPACK FOOTER //
// ./src/Constants/MenuItems.ts